<div class="animated fadeInRight">
  <app-lfsa-card-v2 [innTemplateButton]="innTemplateButton" [innTemplate]="enviarTemplateEdit"
    modulo="Promociones" [tituloCard]="idPromo + '-' + desc + ' cond. grupo clientes'" titulo="Promociones">
  </app-lfsa-card-v2>
</div>

<ng-template #innTemplateButton>
  <div class="col-md-6 text-end mb-2">
    <div *ngIf="!verFormularioAgregarCondGrupoCliente">
      <button class="btn btn-outline-danger me-2" routerLink="..">
        <i class="fas fa-arrow-left"></i>
      </button>
      <button class="btn btn-outline-success" (click)="nuevoCondGrupoCliente()">
        <i aria-hidden="true" class="fa fa-plus"></i>
        Nueva condición
      </button>
    </div>
  </div>
</ng-template>

<ng-template #enviarTemplateEdit>
  <div *ngIf="!verFormularioAgregarCondGrupoCliente">
    <button class="btn btn-danger mb-3" (click)="eliminarTodo()">Eliminar todo</button>
    <ag-grid-angular #agGridBonificadores (gridReady)="onGridReady($event)" class="ag-theme-alpine"
      [columnDefs]="columnDefsCondGrupoCliente" [floatingFilter]="true" [frameworkComponents]="frameworkComponents"
      id="myGridListGaritas" [ngStyle]="{width: '100%', height: '400px'}" [paginationPageSize]="15"
      [pagination]="true" [rowData]="rowDataCondGrupoCliente">
    </ag-grid-angular>
  </div>
  <app-promo-grupo-cliente-form
    [idPromo]="idPromo"
    [groups]="rowDataCondGrupoCliente"
    (back)="back()"
    (create)="guardarCondGrupoCliente($event)"
    *ngIf="verFormularioAgregarCondGrupoCliente"></app-promo-grupo-cliente-form>
</ng-template>
